import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/(multi-location)/admin/")({
  beforeLoad: () => {
    redirect({ to: "/admin/bookings", throw: true });
  },
});
